module.exports = "<div class=\"hp-loading-spinner\">\n\t<div class=\"ra-spinner\" ng-show=\"show\">\n\t\t<img ng-show=\"imgSrc\" ng-src=\"{{imgSrc}}\" />\n\t\t<div class=\"spinner-container-legacy\">\n\t\t\t<div class=\"spinner\"></div>\n\t\t</div>\n\t\t<p>{{text}}</p>\n\t</div>\n\t<div ng-transclude ng-hide=\"hideContentWhenShown && show\"></div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/common/spinner/template/defaultSpinnerTemplate.html
// module id = 808
// module chunks = 1